(function() {
  define('bazemont/survey/edit',['angular', 'angularAnimate', 'angularBootstrap'], function() {
    'use strict';
    return angular.module('bazemontSurveyEdit', ['ngAnimate', 'ui.bootstrap']).component('bazemontSurveyEdit', {
      template: '<a href="" ng-click="$ctrl.openModal()" ng-transclude></span>',
      transclude: true,
      bindings: {
        surveyId: '@?'
      },
      controller: [
        '$uibModal', function($uibModal) {
          this.openModal = function() {
            return $uibModal.open({
              templateUrl: '/assets/javascripts/bazemont/survey/edit.html',
              controllerAs: '$ctrl',
              bindToController: true,
              resolve: {
                data: {
                  surveyId: this.surveyId
                }
              },
              controller: [
                '$uibModalInstance', '$scope', '$window', 'data', 'Survey', 'TlhArrayService', 'TlhNotificationService', function($uibModalInstance, $scope, $window, data, Survey, TlhArrayService, TlhNotificationService) {
                  var endsBeforeStart, handleDateChange, hasAtLeastNCompletedAnswers, setDatepickersOptions, validateForm, vm;
                  vm = this;
                  vm.$onInit = function() {
                    if (data.surveyId) {
                      vm.survey = {};
                      return Survey.get({
                        id: data.surveyId
                      }, function(result) {
                        vm.survey = result;
                        return setDatepickersOptions();
                      });
                    } else {
                      vm.survey = {
                        startsOn: new Date(),
                        answers: [
                          {
                            isActive: true
                          }, {
                            isActive: true
                          }
                        ]
                      };
                      return setDatepickersOptions();
                    }
                  };
                  setDatepickersOptions = function() {
                    var endsOnDate, endsOnMinDate, startsOn, startsOnMinDate;
                    startsOn = vm.survey.startsOn ? new Date(vm.survey.startsOn) : null;
                    endsOnMinDate = startsOn ? startsOn : null;
                    vm.endsOnDatepickerOptions = {
                      minDate: endsOnMinDate,
                      initDate: endsOnMinDate
                    };
                    endsOnDate = vm.survey.endsOn ? new Date(vm.survey.endsOn) : null;
                    startsOnMinDate = null;
                    return vm.startsOnDatepickerOptions = {
                      minDate: startsOnMinDate,
                      maxDate: endsOnDate,
                      initDate: endsOnDate
                    };
                  };
                  handleDateChange = function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                      return setDatepickersOptions();
                    }
                  };
                  validateForm = function() {
                    vm.form.answers.$setValidity('nMinAnswers', hasAtLeastNCompletedAnswers(2, vm.survey.answers));
                    return vm.form.endsOn.$setValidity('endsBeforeStart', !endsBeforeStart(vm.survey.startsOn, vm.survey.endsOn));
                  };
                  hasAtLeastNCompletedAnswers = function(min, answers) {
                    var answer, nb, result, _i, _len;
                    result = false;
                    nb = 0;
                    for (_i = 0, _len = answers.length; _i < _len; _i++) {
                      answer = answers[_i];
                      if (answer.value && ++nb >= min) {
                        result = true;
                        break;
                      }
                    }
                    return result;
                  };
                  endsBeforeStart = function(start, end) {
                    return start && end && new Date(end).getTime() < new Date(start).getTime();
                  };
                  $scope.$watch(function() {
                    return vm.survey.startsOn;
                  }, handleDateChange);
                  $scope.$watch(function() {
                    return vm.survey.endsOn;
                  }, handleDateChange);
                  vm.addAnswer = function() {
                    if (!vm.submitting) {
                      return vm.survey.answers.push({
                        isActive: true
                      });
                    }
                  };
                  vm.removeAnswer = function(answer) {
                    if (answer.id) {
                      console.log('isActive=false');
                      return answer.isActive = false;
                    } else {
                      console.log('splice!');
                      return vm.survey.answers.splice(vm.survey.answers.indexOf(answer), 1);
                    }
                  };
                  vm.getNbActiveAnswers = function() {
                    return TlhArrayService.getNbActiveElements(vm.survey.answers);
                  };
                  vm.submit = function() {
                    validateForm();
                    if (vm.form.$valid && !vm.submitting) {
                      TlhNotificationService.info({
                        message: 'Enregistrement en cours...',
                        delay: false
                      });
                      vm.submitting = true;
                      return new Survey(vm.survey).$save().then(function(response) {
                        TlhNotificationService.success({
                          message: 'Enregistrement terminé',
                          replaceMessage: true
                        });
                        console.log(response);
                        return $window.location.href = response.url;
                      })["catch"](function(error) {
                        var message;
                        console.error(error);
                        message = "L'enregistrement a échoué :<br>";
                        message += error.data ? error.data : "Erreur inattendue, veuillez contacter l'administrateur.";
                        return TlhNotificationService.error({
                          message: message,
                          replaceMessage: true,
                          delay: false
                        });
                      })["finally"](function() {
                        return vm.submitting = false;
                      });
                    }
                  };
                  vm.close = function() {
                    return $uibModalInstance.dismiss();
                  };
                }
              ]
            });
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=edit.js.map
;
